import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input } from '@angular/core';
import { SetDetailInfo } from 'components/cs-log-detail-popover/cs-log-detail-popover';

import { LL } from 'i18n/i18n.service';
@Component({
  selector: 'cs-log-detail-content',
  templateUrl: 'cs-log-detail-content.html',
  host: { 'class': 'log-detail-content' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsLogDetailContent implements AfterViewInit {
  protected LL = LL;
  @Input() sets: SetDetailInfo[] = [];
  isInPopover = false;

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private cdr: ChangeDetectorRef
  ) {}

  ngAfterViewInit() {
    this.isInPopover = this.elementRef.nativeElement.closest('popover-host') !== null;
    this.cdr.detectChanges();
  }

  get hasNotes(): boolean {
    return this.sets.some(s => s.userNotes);
  }

  get setsWithNotes(): SetDetailInfo[] {
    return this.sets.filter(s => s.userNotes);
  }
}
